import { Card, Image, Text, Box, Overlay } from '@mantine/core';
import PropTypes from 'prop-types';
import { colors } from '../constants';


const PlantCard = ({ plant, image, isSelected, onSelect, shouldDisplayText, isMobile = false, subscribedPlan }) => {
  // TODO: Revert default level to 0 after Free Trail level defined
  console.log("PLANTCARD: subscribedPlan = ", JSON.stringify(subscribedPlan));
  const { level } = subscribedPlan ?? { level: 0 };
  const plantIncludedInPlan = (plant['Subscription Levels'] ?? 0) <= level;
console.log("PLANTCARD: level =  ", level);
  const handleClick = () => {
    if (plantIncludedInPlan) {
      onSelect();
    }
  };

  const cardStyle = isMobile ? {
    width: "22vw",
    height: "13vh",
    backgroundColor: isSelected ? 'var(--selected-color)' : 'var(--foreground-window-color)',
    cursor: 'pointer',
    transition: 'background-color 0.3s, border-color 0.3s',
    flexShrink: 0,
    padding: "1vw",
  } : {
    width: 150,
    height: 160,
    backgroundColor: isSelected ? 'var(--selected-color)' : 'var(--foreground-window-color)',
    cursor: 'pointer',
    transition: 'background-color 0.3s, border-color 0.3s',
    flexShrink: 0,
    padding: 10,
  };

  const imageStyle = isMobile ? {
    width: "19vw",
    height: "7vh",
    objectFit: 'contain',
    backgroundColor: '#ffffff',
    borderRadius: "1vw",
    marginBottom: "1vw",
  } : {
    width: 120,
    height: 90,
    objectFit: 'contain',
    backgroundColor: '#ffffff',
    borderRadius: 8,
    marginBottom: 8,
  };

  const textStyle = isMobile ? {
    textWrap: 'wrap',
    minHeight: '20px',
    fontSize: '10px',
    lineHeight: '12px'
  } : {
    textWrap: 'wrap',
    minHeight: '60px'
  };
console.log('plant: ', plant['Subscription Levels']);
console.log('level: ', (plant['Subscription Levels'] ?? 0) <= level);

  return (
    <Card
      shadow="sm"
      padding="md"
      radius="md"
      withBorder
      style={cardStyle}
      onClick={handleClick}
    >
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%' }}>
        <Image
          src={image}
          alt={plant.Common}
          style={imageStyle}
        />
        <Text size="sm" c="white" ta="center" style={textStyle}>
          {shouldDisplayText && plantIncludedInPlan ? plant.Common : ''}
        </Text>
        {!plantIncludedInPlan && (
          <Overlay
            color={colors.white}
            backgroundOpacity={0.6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              cursor: 'not-allowed',
            }}
          >
            <Text size="xs" c={colors.black} ta="center" fw={600}>
              {isMobile ? 'Premium' : 'Premium Plant'}
            </Text>
          </Overlay>
        )}
      </Box>
    </Card>
  );
};

PlantCard.propTypes = {
  plant: PropTypes.shape({
    Common: PropTypes.string.isRequired,
    'Subscription Levels': PropTypes.number,
  }).isRequired,
  image: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  shouldDisplayText: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  subscribedPlan: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    level: PropTypes.number.isRequired,
  }).isRequired,
};

export default PlantCard;
